// Shared UI values. Keep document formatting separate from interface typography.
export const scribeTokens = {
  fontFamily: 'Inter, "Noto Sans TC", system-ui, sans-serif',
  typography: {
    page: { fontSize: 24, fontWeight: 700, lineHeight: 1.35 },
    heading: { fontSize: 20, fontWeight: 700, lineHeight: 1.4 },
    section: { fontSize: 16, fontWeight: 600, lineHeight: 1.5 },
    body: { fontSize: 14, fontWeight: 400, lineHeight: 1.6 },
    label: { fontSize: 14, fontWeight: 600, lineHeight: 1.5 },
    helper: { fontSize: 12, fontWeight: 400, lineHeight: 1.5 },
    content: { fontSize: 16, fontWeight: 400, lineHeight: 1.75 },
  },
  colors: {
    brand: '#29C0BB', brandHover: '#1DA8A3', brandSoft: '#F0FDFA', brandBorder: '#B6DAD7',
    accent: '#7C3AED', accentHover: '#6D28D9', accentSoft: '#F3EEFF', accentBorder: '#C4B5FD',
    text: '#253346', secondary: '#667085', muted: '#82909E',
    surface: '#FFFFFF', subtle: '#F7F9FA', canvas: '#F5F7F9',
    border: '#E2E8ED', disabled: '#E8ECEF', disabledText: '#7C8996',
    danger: '#C7433C', dangerHover: '#AC352F', dangerSoft: '#FFF1F0',
    warning: '#9C762A', highlight: '#FFF0A6', highlightOutline: '#D49B00',
  },
  radius: { panel: 12, control: 8, item: 8, pill: 999 },
  space: { xs: 4, sm: 8, md: 12, lg: 16, xl: 24 },
  controlHeight: { normal: 40, compact: 32 },
  iconSize: { normal: 20, compact: 18 },
  shadow: { selected: '0 1px 4px rgba(24, 71, 69, 0.12)' },
};
